import type { PlayerRace } from '@kaeliux/shared';

export interface FactionPerk {
    text: string;
    /** `edge` is an advantage, `cost` is the trade-off paid for it. */
    kind: 'edge' | 'cost';
}

export interface FactionCopy {
    /** The one-line identity, reused wherever a faction needs a short trait. */
    epithet: string;
    pitch: string;
    perks: FactionPerk[];
}

/**
 * Player-facing faction copy. The auth-page triad and the race picker both
 * read from here so a faction never describes itself two different ways.
 */
export const FACTION_COPY: Record<PlayerRace, FactionCopy> = {
    humans: {
        epithet: 'Master thieves',
        pitch: 'Raiders by trade. Human fleets hit harder and take what they want.',
        perks: [{ text: 'Stronger fleets', kind: 'edge' }],
    },
    robots: {
        epithet: 'Master automators',
        pitch: 'Assembly lines that never rest. Robots turn out new ships faster than anyone.',
        perks: [{ text: 'Faster ship builds', kind: 'edge' }],
    },
    axons: {
        epithet: 'Master budgeteers',
        pitch: 'Axons build lean. Their ships cost less, at the price of size and speed.',
        perks: [
            { text: 'Cheaper ships', kind: 'edge' },
            { text: 'Slower, smaller ships', kind: 'cost' },
        ],
    },
};

export const FACTION_ORDER: PlayerRace[] = ['humans', 'robots', 'axons'];
